import api from '@/services/api';

const ENDPOINT_BASE = 'orden-produccion';

const resultado_produccion_ot_service = {
  async obtenerResultados(codigoOrdenProduccion) {
    const url = `/${ENDPOINT_BASE}/${codigoOrdenProduccion}/resultado-produccion`;

    try {
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('[SERVICE] ❌ Error en obtenerResultados:', error);
      throw error;
    }
  },

  async obtenerResultadoPorCantidad(codigoOrdenProduccion, codigoCantidad) {
    const url = `/${ENDPOINT_BASE}/${codigoOrdenProduccion}/resultado-produccion/${codigoCantidad}`;

    try {
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('[SERVICE] ❌ Error en obtenerResultadoPorCantidad:', error);
      throw error;
    }
  },
};

export default resultado_produccion_ot_service;
